/**
 * Legacy InventoryB2CApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.inventoryB2CApi`) keep resolving.
 *
 * The actual `InventoryB2CApiService` is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/inventory-b2c/inventory-b2c-api.service.ts
 */
angular.module('acme.common.service.inventoryB2CApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder',
]);
